<script setup lang="ts">
import { useRoute } from 'vue-router'
import { getFloorMayLike } from '~/server/newhouse'
import { useCityInfoStore } from '~/stores/useCityInfo'
import { useRongIMChat } from '~/composables/useRongIMChat'

const route = useRoute()
const { city } = useCityInfoStore()
const { initRongIMChatMsg } = useRongIMChat()
/**
 * 猜你喜欢数据获取
 */
const { data: floorMayLikeData } = await useAsyncData(() => getFloorMayLike({ cityId: city, current: 1, pageSize: 5 }), {
  transform(res) {
    const { code, dataBody = [] as any[] } = res
    return code === 0 ? dataBody.list : []
  },
})
// TDK所需参数
const paramsRef = computed(() => {
  return {
    cityId: city,
    floorId: route.params.floorId,
    floorNewsTab: route?.params?.floorNewsTab ?? '', // 楼盘动态标签参数 0：全部
    houseModelId: route?.params?.houseModelId ?? '', // 户型ID
    rankingTypeId: route?.params?.rankingTypeId ?? '', // 榜单类型ID
    themeId: route?.params?.themeId ?? '', // 主题找房-主题ID入参
  }
})
// 获取TDK数据
const { tdkData, refresh } = await useMeta(paramsRef)
// 设置页面TDK参数
function setTDK() {
  useHead({
    title: tdkData.value?.title ?? '房产超市',
    meta: [
      { name: 'keywords', content: tdkData.value?.keywords ?? '' },
      { name: 'description', content: tdkData.value?.description ?? '' },
    ],
  })
}
setTDK()
onMounted(() => {
  initRongIMChatMsg()
})
// 监听路由切换
watch(() => route.fullPath, async () => {
  await refresh()
  setTDK()
  initRongIMChatMsg()
})
</script>

<template>
  <!--  顶部菜单 -->
  <ModuleSwitching />
  <!--  搜索框 -->
  <SearchTop />
  <NuxtPage :layout-data="tdkData" />
  <Container>
    <!--  面包屑 -->
    <Breadcrumb :tdk-data="tdkData" />
    <!--    猜你喜欢 -->
    <MaybeLike :data-list="floorMayLikeData" />
    <!--    底部footer -->
    <Footer :tdk-data="tdkData" />
  </Container>
</template>

<style scoped lang="scss">

</style>
